import { render, staticRenderFns } from "./ProformaTabs.vue?vue&type=template&id=b1f50a12&scoped=true"
import script from "./ProformaTabs.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProformaTabs.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1f50a12",
  null
  
)

export default component.exports